import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import SquareCheckboxIcon from './SquareCheckboxIcon';
import { colors } from '../../../theme/theme';

interface SquareCheckmarkProps {
  label?: string;
  checked: boolean;
  onChange: (...args: any[]) => void;
  sx?: SxProps;
}

const SquareCheckmark = ({
  label = '',
  checked,
  onChange,
  sx,
}: SquareCheckmarkProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        ...sx,
      }}
    >
      <SquareCheckboxIcon checked={checked} onClick={onChange} />
      <Typography
        variant="body3"
        onClick={onChange}
        sx={{
          color: colors.lightText,
          cursor: 'pointer',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default SquareCheckmark;
